var map = {
	"./commerical-studies": [
		23280,
		280
	],
	"./commerical-studies.tsx": [
		23280,
		280
	],
	"./confirm-research-activity": [
		95737,
		737
	],
	"./confirm-research-activity.tsx": [
		95737,
		737
	],
	"./funders": [
		70453,
		453
	],
	"./funders.tsx": [
		70453,
		453
	],
	"./home": [
		55796,
		796
	],
	"./home.tsx": [
		55796,
		796
	],
	"./interactive-costing": [
		68919,
		919
	],
	"./interactive-costing.tsx": [
		68919,
		919
	],
	"./iras-submission": [
		94109,
		109
	],
	"./iras-submission.tsx": [
		94109,
		109
	],
	"./paf-submissions": [
		10585,
		585
	],
	"./paf-submissions.tsx": [
		10585,
		585
	],
	"./portfolio-dashboard": [
		83184,
		184
	],
	"./portfolio-dashboard.tsx": [
		83184,
		184
	],
	"./rts": [
		6228,
		228
	],
	"./rts.tsx": [
		6228,
		228
	],
	"./service-applications": [
		77522,
		522
	],
	"./service-applications.tsx": [
		77522,
		522
	],
	"./soecat-completed": [
		6752,
		752
	],
	"./soecat-completed.tsx": [
		6752,
		752
	],
	"./studies": [
		24064,
		64
	],
	"./studies-requiring-action": [
		66354,
		354
	],
	"./studies-requiring-action.tsx": [
		66354,
		354
	],
	"./studies.tsx": [
		24064,
		64
	],
	"./submit-research-activity": [
		47577,
		577
	],
	"./submit-research-activity.tsx": [
		47577,
		577
	],
	"./terms-and-conditions": [
		18011,
		11
	],
	"./terms-and-conditions.tsx": [
		18011,
		11
	],
	"./user-list": [
		75887,
		887
	],
	"./user-list.tsx": [
		75887,
		887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 39077;
module.exports = webpackAsyncContext;